import ActionTypes from '../../action-types';
import { onPending, onFulfill, onReject } from '../../util';

const initialState = {
  items: [],
  loading: false,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case onPending(ActionTypes.JOB_GET_ALL):
      return {
        ...state,
        loading: true,
        error: null
      };

    case onFulfill(ActionTypes.JOB_GET_ALL):
      return {
        ...state,
        items: action.payload.jobs,
        loading: false,
        error: null
      };

    case onReject(ActionTypes.JOB_GET_ALL):
      return {
        ...state,
        error: action.payload,
        loading: false
      };
    case onFulfill(ActionTypes.LOGOUT):
      return initialState;
    case onFulfill(ActionTypes.JOB_ACTIVATE):
      return {
        ...state,
        items: state.items.map(job => ({
          ...job,
          isActive: job.jobId === action.payload.jobId
        }))
      };
    default:
      return state;
  }
};

export const selectors = {
  activeJob: state => state.job.list.items.filter(job => job.isActive)[0],
  activeJobTitle: state => {
    const activeJob = selectors.activeJob(state);
    if (activeJob) {
      const { title, jobId } = activeJob;
      return title || jobId;
    }
    return null;
  }
};
